<template>
  <div class="uk-flex" style="width: 506px;">
    <div class="hidden">
      <label>
        <input
          id="files"
          ref="files"
          type="file"
          multiple
          :accept="acceptExtensions"
          @change="handleFilesUpload"
        />
      </label>
    </div>
    <div class="file-wrapper uk-flex uk-flex-wrap uk-width-1-1">
      <div v-show="!files.length" class="file-empty">
        Нет добавленных файлов
      </div>
      <div v-for="(file, key) in files" :key="key" class="file-listing">
        <i :uk-icon="`icon: ${getIcon(file.name)}`" class="uk-preserve"></i>
        {{ shortenName(file.name) }}
        <span
          class="remove-file"
          uk-icon="icon: close; ratio: 0.65;"
          @click="removeFile(key)"
        ></span>
      </div>
      <div
        v-show="isDisabled"
        class="file-listing--warning"
        v-text="`К сожалению, к вопросу нельзя добавить более ${filesLimit} файла`"
      ></div>
    </div>
    <b-button name="Добавить" :disabled="isDisabled" @click.stop="addFiles" />
  </div>
</template>

<script>
export default {
  name: 'b-file-uploader',
  props: {
    LoadFiles: {
      type: Array,
      default: () => []
    },
    filesLimit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      files: this.LoadFiles,
      fileSizeLimitedMb: 10,
      nameLengthLimit: 10,
      isDisabled: false,
      acceptExtensions:
        '.ppt, .pptx, .pps, .ppsx, .doc, .docx, .xls, .xlsx, .svg, .pdf, .bmp, .jpg, .jpeg, .png',
      supportMIMETypes: [
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-pps',
        'application/mspowerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/svg+xml',
        'application/pdf',
        'image/bmp',
        'image/jpeg',
        'image/png'
      ],
      deletedFiles: []
    }
  },
  methods: {
    addFiles() {
      if (this.filesLimit <= this.files.length) {
        this.isDisabled = true
        return
      }
      this.$refs.files.click()
    },
    handleFilesUpload() {
      let uploadedFiles = this.$refs.files.files

      if (uploadedFiles.length + this.files.length <= this.filesLimit) {
        for (let i = 0; i < uploadedFiles.length; i++) {
          if (this.supportMIMETypes.includes(uploadedFiles[i].type)) {
            let size = (uploadedFiles[i].size / 1024 / 1024).toFixed(1)
            if (size <= this.fileSizeLimitedMb) {
              this.files.push(uploadedFiles[i])
              this.$emit('change', this.files)
            } else {
              this.$UIKit.notification(
                `Файл "${this.shortenName(uploadedFiles[i].name)}" больше ${
                  this.fileSizeLimitedMb
                } Mb`,
                {
                  pos: 'top-right',
                  timeout: 3000
                }
              )
            }
          } else {
            this.$UIKit.notification(
              `Файл "${this.shortenName(uploadedFiles[i].name)}" имеет неподдерживаемый формат.`,
              {
                pos: 'top-right',
                timeout: 3000
              }
            )
          }
        }
      } else {
        this.$UIKit.notification(`Можно загрузить до ${this.filesLimit} файлов`, {
          pos: 'top-right',
          timeout: 3000
        })
      }
    },
    removeFile(key) {
      this.isDisabled = false

      if (this.files[key] instanceof File) {
        this.$refs.files.value = ''
        this.files.splice(key, 1)
      } else {
        if (!this.deletedFiles.some(el => el === this.files[key].id)) {
          this.deletedFiles.push(this.files[key].id)
        }
        this.files.splice(key, 1)
      }
      this.$emit('remove', key)
      this.$emit('deletedFiles', this.deletedFiles)
    },
    shortenName(name) {
      let filename = this.getFilename(name)
      let extension = this.getExtension(name)

      if (filename.length > this.nameLengthLimit) {
        filename = filename.substring(0, this.nameLengthLimit) + '...'
      }

      return filename + '.' + extension
    },
    getExtension(name) {
      return name.substring(name.lastIndexOf('.') + 1)
    },
    getFilename(name) {
      return name.substring(0, name.lastIndexOf('.'))
    },
    getIcon(name) {
      let extension = this.getExtension(name).toLowerCase()
      switch (extension) {
        case 'ppt':
        case 'pptx':
        case 'pps':
        case 'ppsx':
          return 'powerpoint'
        case 'doc':
        case 'docx':
          return 'word'
        case 'xls':
        case 'xlsx':
          return 'excel'
        case 'svg':
          return 'svg'
        case 'pdf':
          return 'pdf'
        case 'png':
          return 'png'
        case 'jpg':
        case 'jpeg':
          return 'jpg'
        case 'bmp':
          return 'bmp'
        default:
          return 'file-text'
      }
    },
    clearData() {
      this.deletedFiles = []
    }
  },
  watch: {
    LoadFiles() {
      this.files = this.LoadFiles
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden {
  position: absolute;
  left: -9999px;
  z-index: -5;
}

input[type='file'] {
  position: absolute;
  z-index: -5;
}

.file-listing {
  position: relative;
  height: 30px;
  margin-bottom: 18px;
  font-size: 1rem;
  color: #222222;
  white-space: nowrap;

  &:not(:last-child) {
    margin-right: 24px;
  }

  &--warning {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.375;
    color: #e13035;
  }
}

.file-empty {
  padding-left: 10px;
  font-size: 1.125rem;
  line-height: 1;
  color: rgba(34, 34, 34, 0.6);
}

.file-wrapper {
  padding: 0 10px;
}

.remove-file {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(100%, -3px);
  cursor: pointer;

  &:hover {
    color: red;
  }
}
</style>
